/**
 * Moved from APM.js by c_samarska_d on 12/10/2018.
 *
 */
'use strict';
var $ = require('jquery');

function initPopOver(customPopoverClass) {
    $('[data-toggle=popover]').popover({
        html : true,
        placement: 'auto bottom',
        container: '.journey-container',
        viewport: { selector: 'body', "padding": 5 },
        content: function() {
            var content = $(this).attr("data-popover-content");
            return $('#'+content).html();
        }
    }).data('bs.popover').tip().addClass(customPopoverClass);

    $('.journey-container').on('click','.popover__close-button', function(event) {
        var triggerId =$(event.target).attr('data-popover-trigger');
        $('#'+triggerId).popover('hide');
    });
}

/**
 * When the user drags the carousel, hide the popover if it is displayed
 * @param el - The element that is clicked that needs the focus to be removed after the mouse touchmove has finished
 */
function initClosePopOverOnCarouselTouchmove(el) {
    $('.owl-carousel').on({
        'touchmove': function(e) {
            if($('.popover').is(":visible")) {
                $('.popover').popover('hide');
            }
        }
    }).on({'touchend': function(e){
        $(el).blur();
    }});
}

module.exports.initPopOver = initPopOver;
module.exports.initClosePopOverOnCarouselTouchmove = initClosePopOverOnCarouselTouchmove;



//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/modules/utils/popover.js
// module id = z0NW
// module chunks = 1 2